import React from 'react';
import ReadMoreText from '../read-more-text';
import { ARTICLE_READING_TIME_TEXT, HERO, MINIMAL_HERO } from '../../app-constants';
import { Desktop } from '../../app-responsive';
import CardHeader from './card-header';

const CardContent = (props) => {
  const {
    img: { imgSrc, imgClass },
    data: { linkSrc, articleId, title, summary, layoutMode },
    metaData: { readingTime },
    cardBodyClass = '' } = props.values;
  const isHero = layoutMode === HERO;

  const CardImage = () => (
    <span className="card-img card-img-wrapper">
      <img src={imgSrc} className={imgClass} alt="" />
      <p className="card-img-overlay reading-text">{`${readingTime} ${ARTICLE_READING_TIME_TEXT}`}</p>
    </span>
  );
  const ContentSection = () => (
    <div className="content-section">
      <h4 className="card-title">{title}</h4>
      <ReadMoreText contentText={summary} articleId={articleId} linkUrl={linkSrc} layoutMode={layoutMode} />
      { isHero
        ? <Desktop><CardHeader metaContent={props.values} /></Desktop>
        : null
      }
    </div>
  );
  const Layout = () => {
    let layout;
    switch (layoutMode) {
      case HERO:
        layout = (
          <div className="row">
            <div className="col-sm-7">
              <CardImage />
            </div>
            <div className="col-sm-5">
              <ContentSection />
            </div>
          </div>);
        break;
      case MINIMAL_HERO:
        layout = (
          <div className="row">
            <div className="col-12">
              <CardImage />
              <ContentSection />
            </div>
          </div>);
        break;
      default:
        layout = (
          <div className="row">
            <div className="col-sm">
              <CardImage />
              <ContentSection />
            </div>
          </div>);
    }
    return layout;
  };


  return <div className={`${cardBodyClass} mbs_card-body`}><Layout /></div>;
};

export default CardContent;
